<div class="flex justify-center">
  <div [class]="isConfirmationPage ? 'account-container-inner-smaller' : 'account-container-inner'">
    <div>
      <span class="amountText">{{ data.selectedPaymentAmount | currencyUSD }}</span>
      @if (!isConfirmationPage) {
        <div class="amountSubtext">{{ amountSubheading }}</div>
      }
      @if (isRecurringPage && !isConfirmationPage) {
        <div class="amountSubtext">{{ recurringSubtext }}</div>
      }
    </div>
    <div style="margin-top: 24px; justify-self: anchor-center">
      <div class="paymentContent">
        <div class="subHeadingsText" style="margin-top: 0px">
          <span dsContent [contentPath]="'billing.phoenixPayment.paymentFor'"></span>
        </div>
        <div>
          @for (risk of risks; track $index) {
            <p class="subHeadingText">
              {{ risk }}
            </p>
          }
        </div>
      </div>
      <div class="paymentContent">
        <div class="subHeadingsText">
          <span dsContent [contentPath]="'billing.phoenixPayment.paymentAmount'"></span>
        </div>
        <div class="subHeadingContent">
          {{ data.selectedPaymentAmount | currencyUSD }}
        </div>
      </div>
      @if (isRecurringPage) {
        <div class="paymentContent">
          <div class="subHeadingsText">
            <span dsContent [contentPath]="'billing.recurring.paymentFrequency'"></span>
          </div>
          <div class="subHeadingContent">
            {{ data.frequency }}
          </div>
        </div>
      } @else {
        <div class="paymentContent">
          <div class="subHeadingsText">
            <span dsContent [contentPath]="'billing.phoenixPayment.paymentDate'"></span>
          </div>
          <div class="subHeadingContent">
            {{ data.dueDate | dateFormat: 'MMM DD, YYYY' }}
          </div>
        </div>
      }
      <div class="paymentContent">
        <div class="subHeadingsText">
          <span dsContent [contentPath]="'billing.phoenixPayment.paymentMethods'"></span>
        </div>
        <div class="subHeadingContent" [innerHTML]="data.cardDetails"></div>
      </div>
      @if (showActionLink) {
        <ds-jump-links [jumpLinks]="print" size="medium"></ds-jump-links>
      }
    </div>
  </div>
</div>
